import React from "react";
import Card from "components/card";
import Button from "components/button/Button";
import CommonModal from "components/modals/Modal";
import { createPortal } from "react-dom";
import { useDisclosure } from "@chakra-ui/hooks";
import { useNavigate } from "react-router-dom";
import { FaTags, FaTrash } from "react-icons/fa";
import { IBrand } from "views/admin/goods/types/brand.interface";
import {
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  ModalHeader,
} from "@chakra-ui/modal";

interface IBrandCardProps extends IBrand {
  onDelete?: (slug: string) => void;
}

const BrandCard: React.FC<IBrandCardProps> = (props) => {
  const navigate = useNavigate();
  const { name, image, description, slug, id, onDelete } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [modalAction, setModalAction] = React.useState<
    "show" | "confirmation"
  >();
  const [imageTarget, setImageTarget] = React.useState<string>("");

  return (
    <>
      <Card extra={`flex flex-col w-full h-full !p-4 3xl:p-![18px] bg-white`}>
        <div className="h-full w-full">
          <div className="relative mb-1 w-full overflow-hidden">
            {image ? (
              <img
                src={`${process.env.REACT_APP_PUBLIC_URL}/${image}`}
                className="mb-3 h-56 w-full rounded-xl object-contain object-center"
                alt={name}
              />
            ) : (
              <div className="flex h-56 w-full items-center justify-center rounded-xl bg-brand-50 bg-opacity-25">
                <FaTags className="h-12 w-12 text-brand-500" />
              </div>
            )}
          </div>

          <div className="mb-3 flex items-center justify-between px-1 md:flex-col md:items-start lg:flex-row lg:justify-between xl:flex-col xl:items-start 3xl:flex-row 3xl:justify-between">
            <div className="flex w-full">
              <div className="mb-2 flex flex-col overflow-hidden">
                <p className="truncate text-lg font-bold text-navy-700 dark:text-white">
                  {" "}
                  {name}
                </p>
                <div className="flex flex-col overflow-hidden">
                  <p className="mt-1 truncate text-sm font-medium text-gray-600">
                    {description || "-"}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="flex w-full justify-end">
            <div className="flex items-center justify-between gap-2">
              <Button
                size="fit"
                children={
                  <div className="flex h-5 items-center">
                    <FaTrash className="text-xs text-white" />
                  </div>
                }
                variant="danger"
                onClick={() => {
                  setModalAction("confirmation");
                  onOpen();
                }}
              />
              <Button
                size="fit"
                children="Edit"
                variant="gray"
                onClick={() => {
                  navigate(`/admin/brands/edit/${slug}`);
                }}
              />
              <Button
                size="fit"
                children="Detail"
                variant="primary"
                onClick={() => {
                  setModalAction("show");
                  onOpen();
                }}
              />
            </div>
          </div>
        </div>
      </Card>
      {createPortal(
        <CommonModal
          size="2xl"
          children={
            <div>
              <ModalHeader>
                {modalAction === "show" ? "Detail" : "Konfirmasi"}
              </ModalHeader>
              <ModalCloseButton />
              <ModalBody>
                {modalAction === "show" ? (
                  <div className={`flex h-full w-full flex-col bg-white`}>
                    <div className="h-full w-full">
                      <div className="relative mb-4 w-full overflow-hidden">
                        {image ? (
                          <img
                            src={
                              image
                                ? image.includes("https://")
                                  ? image
                                  : `${process.env.REACT_APP_PUBLIC_URL}/${
                                      imageTarget !== "" ? imageTarget : image
                                    }`
                                : "https://placehold.co/600x400?text=No+Thumbnail"
                            }
                            className="mb-3 h-full max-h-32 w-full rounded-xl object-contain object-center 3xl:h-full 3xl:w-full"
                            alt=""
                          />
                        ) : (
                          <div className="flex h-56 w-full items-center justify-center rounded-xl bg-brand-50 bg-opacity-25">
                            <FaTags className="h-16 w-16 text-brand-500" />
                          </div>
                        )}
                      </div>

                      <div className="mb-3">
                        <p className="text-lg font-bold text-navy-700 dark:text-white">
                          {" "}
                          {name}{" "}
                        </p>
                      </div>

                      <p className="mt-2 text-base text-gray-700 dark:text-white">
                        {description || "-"}
                      </p>
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-col gap-3">
                    <p className="text-base text-gray-700 dark:text-white">
                      Apakah anda yakin ingin menghapus <br />
                      <span className="text-brand-500">{name}</span>
                    </p>
                  </div>
                )}
              </ModalBody>
              <ModalFooter>
                {modalAction === "show" ? (
                  <Button
                    variant="gray"
                    children="Tutup"
                    size="fit"
                    onClick={onClose}
                  />
                ) : (
                  <div className="flex gap-3">
                    <Button
                      size="fit"
                      children="Batal"
                      variant="gray"
                      onClick={onClose}
                    />
                    <Button
                      size="fit"
                      children={<span className="text-white">Ya, hapus</span>}
                      variant="danger"
                      onClick={() => {
                        onClose();
                        onDelete && onDelete(slug);
                      }}
                    />
                  </div>
                )}
              </ModalFooter>
            </div>
          }
          isOpen={isOpen}
          onClose={onClose}
        />,
        document.body
      )}
    </>
  );
};

export default BrandCard;
